import { Injectable } from '@angular/core';
import { Dictionary } from '@shared';
import { Subject, Observable } from 'rxjs';
import { RequestsStatusEnum } from './models/requests-status.enum';

@Injectable({ providedIn: 'root' })
export class RequestsStatusState {
	private requestsStatus$: Dictionary<Subject<RequestsStatusEnum>> = {};

	public hasAny(): boolean {
		return Object.keys(this.requestsStatus$).length > 0;
	}

	public set(recordId: string | undefined, requestStatus: RequestsStatusEnum): void {
		if (!this.requestsStatus$[recordId]) {
			this.requestsStatus$[recordId] = new Subject();
		}

		this.requestsStatus$[recordId].next(requestStatus);
	}

	public get$(tableName: string, rxdbid: number): Observable<RequestsStatusEnum> | null {
		const recordId = `${tableName}-${rxdbid}`;

		if (!this.requestsStatus$[recordId]) {
			return null;
		}

		return this.requestsStatus$[recordId].asObservable();
	}

	public remove(recordId: string): void {
		if (this.requestsStatus$[recordId]) {
			this.requestsStatus$[recordId].complete();
			delete this.requestsStatus$[recordId];
		}
	}
}
